import { Controller } from "@hotwired/stimulus"

// Shows or hides a target element based on the value of a select.
// Usage:
//   data-controller="conditional-field"
//   data-conditional-field-show-when-value="No"   <- show target when select equals this
//   data-action="change->conditional-field#toggle"
//   The target element should have data-conditional-field-target="field"

export default class extends Controller {
  static targets = ["field"]
  static values = { showWhen: String }

  connect() {
    this.toggle()
  }

  toggle(event) {
    const select = event?.target ?? this.element.querySelector("select")
    const selected = select?.options[select.selectedIndex]?.text
    const show = selected === this.showWhenValue
    this.fieldTargets.forEach(el => {
      el.hidden = !show
    })
  }
}
